var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('img',{staticClass:"img_home",attrs:{"src":require("@/assets/backhome.png")},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();return _vm.goBackHome($event)}}}),_c('div',[_c('iframe',{staticClass:"frame",attrs:{"src":_vm.url,"allowfullscreen":""}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }